import React from 'react'

import SenderBlocked from 'assets/images/qn2c/senderBlocked.svg'
import ActionBase from 'components/pages/quarantineAction/ActionBase'
import ContentHeader from 'components/pages/quarantineAction/ContentHeader'

export interface BlockActionProps {
  user: string
  headerFrom: string
  onClick: () => void
  buttonLabel: string
  buttonBdsType: 'interactiveNeutral' | 'interactiveEmphasis'
  error: boolean
  errorContent: string
  loading: boolean
  icon?: boolean
  content: { header: string; subHeader: string }
  initial: string
}

export const BlockAction: React.FC<BlockActionProps> = ({
  user,
  headerFrom,
  onClick,
  buttonLabel,
  buttonBdsType,
  error,
  errorContent,
  loading,
  icon,
  content,
  initial
}) => (
  <ActionBase
    onClick={onClick}
    buttonLabel={buttonLabel}
    buttonBdsType={buttonBdsType}
    error={!!error}
    errorContent={errorContent}
    loading={loading}
    icon={icon ? <img src={SenderBlocked} alt="Blocked" /> : undefined}
  >
    <ContentHeader initial={initial} headerFrom={headerFrom} user={user} content={content} info="UserInfo" />
  </ActionBase>
)

export default BlockAction
